import { connect } from "react-redux";

import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { withShowOnce } from "../../withShowOnce";

import { Minitour } from "./Minitour";

export interface MinitourProps {
    minitourEnabled?: boolean | Function;
    openedFrom?: string;
    id: string;
}

const mapStateToProps = (state: FullFormState, ownProps: MinitourProps) => {
    let minitourEnabled = true;

    if (typeof ownProps.minitourEnabled === "function") {
        minitourEnabled = ownProps.minitourEnabled.call(this, state);
    } else if (typeof ownProps.minitourEnabled === "boolean") {
        minitourEnabled = ownProps.minitourEnabled;
    }

    if (state.settings.disableMinitours) {
        minitourEnabled = false;
    }

    return {
        id: ownProps.id,
        minitourEnabled: minitourEnabled,
        openedFrom: ownProps.openedFrom ?? ownProps.id,
        userId: state.settings.userId,
    };
};

export const MinitourContainer = connect(mapStateToProps)(withShowOnce(Minitour));
